import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function OpenclawCta() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5287">
      <div className="bg-blue-600 rounded-[2.5rem] shadow-sm border border-blue-500 p-8 md:p-16 relative overflow-hidden" data-id="element-5288">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-5289"></div>
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-5290">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight" data-id="element-5291">
            Ready to hire your AI sales agent?
          </h2>
          <p className="text-lg text-white/80 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-5292">
            Join thousands of sales teams using Openmart to automate their local
            business prospecting and outreach.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-5293">
            <Button href="http://app.openmart.com/register" variant="secondary" size="lg" arrow data-id="element-5294">
              Try for free
            </Button>
          </div>
        </div>
      </div>
    </section>;
}